import { request, RequestInitWithRetry } from '../../lib/request';
import { ISortResult } from '../shared/common';

export interface IDeviceAnomalyDataUsageAppsParams {
  deviceId: string,
  from: number,
  to: number,
  timeZone: string,
  sort: ISortResult
}

export interface IDeviceAnomalyDataUsageAppItem {
  name: string | null,
  packageName: string,
  mobile: number,
  wifi: number,
  total: number,
  averageDailyDataUsage: number
}

export function getDeviceAnomalyDataUsageApps(params: IDeviceAnomalyDataUsageAppsParams) {
  return (options: RequestInitWithRetry): Promise<IDeviceAnomalyDataUsageAppItem[]> => {
    const input = {
      path: '/api/core/anomalies-beta/devices/dataUsageApps',
      body: params,
      method: 'post'
    };
    return request(input, options);
  };
}
